import React from 'react';
import SercurityVerification from '../components/Authentication/SercurityVerification';

const VerificationPage = () => {
	return <SercurityVerification />;
};

export default VerificationPage;
